const showAllBooks = () => {
  const buttons = document.querySelectorAll('.js-show-all-books')

  buttons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault()

      // Find the closest section parent
      const section = button.closest('section.author__content__books')

      if (!section) {
        console.error('Section not found')
        return
      }

      // Find the container within this section
      const container = section.querySelector('.book-columns')

      if (!container) {
        console.error('Container not found in section')
        return
      }

      const hiddenWorks = container.querySelectorAll('.js-hidden-work')

      hiddenWorks.forEach(work => {
        work.style.display = 'block'
      })

      button.style.display = 'none'
    })
  })
}

export default showAllBooks
